import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../carrier/response-container';
import { HttpClient } from '@angular/common/http';
import { timeout, tap } from 'rxjs/operators';
import { TubeRackValidationRequest } from './TubeRackValidationRequest';

@Injectable({
  providedIn: 'root'
})
export class TubeRackService {
  constructor(private http: HttpClient) { }

  defaultTimeout = 600000;
  getCarrierByMaterialBarcode(tubeRackValidationRequest: TubeRackValidationRequest): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + "hamiltonRack/material";
    return this.http.post<BBResponseContainer>(url, tubeRackValidationRequest).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
}
